import { useRef, useState } from "react";

/**
 * Keeps drawer content mounted through the close animation and gives it a
 * fresh `openKey` on every open, so each open starts from clean state.
 */
export function useDrawerContentMount(open: boolean) {
    const openCountRef = useRef(0);
    const prevOpenRef = useRef(open);
    if (open && !prevOpenRef.current) {
        openCountRef.current += 1;
    }
    prevOpenRef.current = open;

    const [isOpen, setIsOpen] = useState(false);

    return {
        shouldRender: isOpen || open,
        openKey: openCountRef.current,
        onAnimationEnd: setIsOpen,
    };
}
